import { Component, OnInit } from '@angular/core';
import { HxAuthService } from 'hx-services';
import { AccessRecentService } from '@adm-web-app/modules/access/services/access-recent.service';
import { AppService } from './app.service';
import { environment } from '@adm-web-env/environment';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ResolveEnd, ResolveStart, Router, RouterLink, RouterOutlet } from '@angular/router';
import { NzContentComponent, NzHeaderComponent, NzLayoutComponent, NzSiderComponent } from 'ng-zorro-antd/layout';
import { NzMenuDirective, NzMenuGroupComponent, NzMenuItemComponent, NzSubMenuComponent } from 'ng-zorro-antd/menu';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NgClass, NgIf } from '@angular/common';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTagComponent } from 'ng-zorro-antd/tag';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzDropdownButtonDirective, NzDropDownDirective, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
  imports: [NzLayoutComponent, NzSiderComponent, NzMenuDirective, NzSubMenuComponent, NzMenuItemComponent, NzMenuGroupComponent, RouterLink, NzIconDirective, NgClass, NzHeaderComponent, NzRowDirective, NzColDirective, NgIf, NzTagComponent, NzTooltipDirective, NzButtonGroupComponent, NzButtonComponent, NzWaveDirective, NzDropdownButtonDirective, NzDropDownDirective, NzDropdownMenuComponent, NzContentComponent, RouterOutlet, NzSkeletonComponent, TranslocoPipe]
})
export class AppComponent implements OnInit {

  isCollapsed = false;
  theme: 'light' | 'dark' = 'light'; // dark
  hasAppUpdate = false;
  isProd = environment.production;
  loading = false;

  constructor(
    public auth: HxAuthService,
    private appService: AppService,
    private tr: TranslocoService,
    private router: Router,
    private recentPeople: AccessRecentService,
  ) {
  }

  ngOnInit(): void {
    this.tr.events$.subscribe(event => {
      console.log('[i18n] transloco event', event);
    });
    this.appService.startUpdateChecker();
    this.appService.update.subscribe(() => this.hasAppUpdate = true);
    this.router.events.subscribe(event => {
      if (event instanceof ResolveStart) {
        this.loading = true;
      } else if (event instanceof ResolveEnd) {
        this.loading = false;
      }
    });
  }

  updateApp() {
    this.appService.updateApp();
  }

  checkForUpdate() {
    this.appService.checkUpdates();
  }

  aboutApp() {
    this.appService.about();
  }

  /** The people «Недавние» of the page «Доступы» are the admin's own: they do not outlive his session on a shared computer. */
  logout() {
    this.recentPeople.clear();
    this.auth.logout();
  }
}
